/* unplugin-vue-components disabled */import script from "./SharingAssistor.vue?vue&type=script&setup=true&lang=js"
export * from "./SharingAssistor.vue?vue&type=script&setup=true&lang=js"

import "./SharingAssistor.vue?vue&type=style&index=0&id=c9178e3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9178e3c"]])

export default __exports__